export default function Footer() {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Inicio', href: '#hero' },
    { name: 'Programación', href: '#schedule' },
    { name: 'Noticias', href: '#news' },
    { name: 'Contacto', href: '#contact' }
  ];

  const socialLinks = [
    { name: 'Facebook', icon: 'ri-facebook-fill', url: 'https://www.facebook.com/Hitscolletionstation' },
    { name: 'Instagram', icon: 'ri-instagram-fill', url: 'https://instagram.com' },
    { name: 'Twitter', icon: 'ri-twitter-x-fill', url: 'https://twitter.com' },
    { name: 'YouTube', icon: 'ri-youtube-fill', url: 'https://youtube.com' }
  ];

  return (
    <footer className="bg-[#d4af37] text-black">
      <div className="px-4 sm:px-8 lg:px-20 py-8 sm:py-12 lg:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-8 sm:mb-12">
          {/* Brand Section */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/90cdc5753254eaf7f1dcae8cf1c8be47/35a559514bc9a3dc6d2caf1f9c98bb98.png" 
                alt="Hits Collections Station" 
                className="h-12 w-12 sm:h-14 sm:w-14 object-contain"
              />
              <span className="font-bold text-lg sm:text-xl" style={{ fontFamily: 'Playfair Display, serif' }}>
                Hits Collections Station
              </span>
            </div>
            <p className="text-black/80 text-xs sm:text-sm leading-relaxed mb-4">
              La mejor música las 24 horas del día. Transmitiendo desde Cúcuta, Colombia para todo el mundo.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-black/10 rounded-full hover:bg-black hover:text-[#d4af37] transition-all duration-300 cursor-pointer"
                  aria-label={social.name}
                >
                  <i className={`${social.icon} text-base sm:text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-base sm:text-lg mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Enlaces Rápidos
            </h3>
            <ul className="space-y-2 sm:space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-black/80 hover:text-black transition-colors duration-300 text-xs sm:text-sm cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-base sm:text-lg mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Contacto
            </h3>
            <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-1 flex-shrink-0"></i>
                <span className="text-black/80">Torres del Bosque, Ciudad de Cúcuta</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-1 flex-shrink-0"></i>
                <span className="text-black/80">+1 (555) 123-4567</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-1 flex-shrink-0"></i>
                <span className="text-black/80 break-all">contacto@hitscollections.com</span>
              </li>
            </ul>
          </div>

          {/* Schedule */}
          <div>
            <h3 className="font-bold text-base sm:text-lg mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Horario
            </h3>
            <div className="space-y-2 text-xs sm:text-sm">
              <div className="flex items-center gap-2">
                <i className="ri-radio-line"></i>
                <span className="text-black/80">Transmisión 24/7</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-customer-service-line"></i>
                <span className="text-black/80">Atención: Lunes - Sábado</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                <span className="text-black/80">9:00 AM - 6:00 PM</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 sm:pt-8 border-t border-black/20">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-xs sm:text-sm">
            <p className="text-black/80 text-center sm:text-left">
              © {currentYear} Hits Collections Station. Todos los derechos reservados.
            </p>
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
              <a href="#" className="text-black/80 hover:text-black transition-colors duration-300 cursor-pointer whitespace-nowrap">
                Política de Privacidad
              </a>
              <a href="#" className="text-black/80 hover:text-black transition-colors duration-300 cursor-pointer whitespace-nowrap">
                Términos de Uso
              </a>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-black/80 hover:text-black transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
